import { Outlet, useNavigate } from "react-router";
import { useProfilStore } from "../stores/useStore";
import { observer } from "mobx-react-lite";
import Header from "../components/general/Header"
import "../style/Play.css";
import { useState, useEffect } from "react";



const Play = observer(() => {
  const profilStore = useProfilStore();
  const navigate = useNavigate();
  useEffect(() => {
    // Important : ne rien faire tant que l'état n’est pas connu
    if (profilStore.isConnected === undefined) return;
  
    if (!profilStore.isConnected) {
      navigate("/Login", {
        state: { reason: "triedPlaying" },
      });
    }
  }, [profilStore.isConnected, navigate]);

  return (
    <main className={`play_main`}>
      <Header admin={profilStore.admin} connected={profilStore.isConnected} imageProfil={profilStore.isConnected&&profilStore.profilPicture?profilStore.profilPicture:undefined}/>
      <Outlet />
    </main>
  );
})

export default Play;
